import { useRef } from 'react'

import {
  calcSplitGroups,
  readSplitBySources
} from '@aytm/app/stats/page/question-views/info-view/components/compare-items/lib/split-groups'

// Split-by groups come from live page state (traits, report virtuals, survey variables) that
// carries no change signal, so they are rebuilt on every render and the previous array is kept
// whenever the rebuild produced the same groups - the DataView re-renders on identity.
export default function useSplitGroups(enabled) {
  const last = useRef({ key: null, groups: null })

  const groups = enabled ? calcSplitGroups(readSplitBySources()) : null
  const key = JSON.stringify(groups)

  if (last.current.key !== key) {
    last.current = { key, groups }
  }

  return last.current.groups
}
